export default "/images/9afbb3a7c4583aa9afcdc96992ef65ea.avif";